import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import Breadcrumb from './Breadcrumb';
import InvoiceView from './InvoiceView';

const InvoiceViewContainer = (props) => {

    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (  
        <div>
            <Breadcrumb title="Invoice View" />
            <InvoiceView invoiceId= {props.location.state.invoiceId} ref={componentRef} />
            <div className="row">
                <div className="col-sm-12">
                    <div className="submit-section" style={{textAlign: 'center', marginBottom: '10px'}}>
                        <button className="btn btn-primary submit-btn" onClick={handlePrint}>Print</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default InvoiceViewContainer;